const BLOCK_SEPARATOR_TAGS = /<\s*(?:br\s*\/?|\/(?:p|div))\s*>/gi;

/** Converts an HTML value to normalized, single-line plain text for table cells. */
export function htmlToPlainText(value) {
  if (value == null) return "";

  const html = String(value).replace(BLOCK_SEPARATOR_TAGS, " ");
  let text;

  if (typeof DOMParser !== "undefined") {
    text = new DOMParser().parseFromString(html, "text/html").body.textContent || "";
  } else if (typeof document !== "undefined") {
    const container = document.createElement("div");
    container.innerHTML = html;
    text = container.textContent || "";
  } else {
    // Defensive fallback for non-browser tooling. Browser rendering uses DOMParser.
    text = html.replace(/<[^>]*>/g, " ");
  }

  return text.replace(/\s+/g, " ").trim();
}

export default htmlToPlainText;
